import React, { ButtonHTMLAttributes, FC, PropsWithChildren, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { cellBackgroundColor, cellIconColor, cellTextColor, cellVariants } from '@shared/config/components/cell';
import { Text } from '@shared/ui/atoms';
import { withTheme } from '@shared/lib/theme';
interface CellProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: keyof typeof cellVariants;
  disabled?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
}
const Cell: FC<PropsWithChildren<CellProps>> = ({
  variant = 'inverted',
  disabled = false,
  startIcon,
  endIcon,
  children,
  ...rest
}) => <CellWrapper variant={variant} disabled={disabled} {...rest}>
    {startIcon && <IconWrapper variant={variant}>{startIcon}</IconWrapper>}
    <Text family="MTSCompact" size="pL" color={cellTextColor(variant)}>
      {children}
    </Text>
    {endIcon && <IconWrapper variant={variant}>{endIcon}</IconWrapper>}
  </CellWrapper>;
export default Cell;
type CellWrapperProps = Required<Pick<CellProps, 'variant' | 'disabled'>>;
const _exp = /*#__PURE__*/() => ({
  variant
}) => cellBackgroundColor(variant);
const _exp2 = /*#__PURE__*/() => ({
  disabled
}) => disabled ? 'default' : 'pointer';
const _exp3 = /*#__PURE__*/() => ({
  disabled
}) => disabled ? 'none' : 'default';
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => `inset 0 0 0 9999px ${theme.colors.background.hover}`;
const CellWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "CellWrapper",
  class: "c7go6nj",
  propsAsIs: false,
  vars: {
    "c7go6nj-0": [_exp()],
    "c7go6nj-1": [_exp2()],
    "c7go6nj-2": [_exp3()],
    "c7go6nj-3": [_exp5()]
  }
}));
type IconWrapperProps = Required<Pick<CellProps, 'variant'>>;
const _exp6 = /*#__PURE__*/() => ({
  variant
}) => cellIconColor(variant);
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i3v2og4",
  propsAsIs: false,
  vars: {
    "i3v2og4-0": [_exp6()]
  }
});

require("./Cell.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Cell.tsx");